import {Button, Table, TableHeaderCellOwnProps} from 'evergreen-ui';
import React, {ElementType} from 'react';
import {BoxComponent} from 'ui-box';

type ClickableColumnHeaderProps = {
    text: string | number;
    icon?: ElementType | null;
    onClick?: () => void;
    loading: boolean;
    buttonClassName?: string;
} & TableHeaderCellOwnProps;
export const ClickableColumnHeader: BoxComponent<ClickableColumnHeaderProps, 'div'> =
    ({
         text,
         icon = null,
         onClick,
         loading,
         buttonClassName,
         ...headerProps
     }: ClickableColumnHeaderProps) => {
        return (
            <Table.HeaderCell padding={0} {...headerProps}>
                <Button paddingX={16} appearance='minimal' intent='none'
                        className={buttonClassName}
                        height={40} iconAfter={icon}
                        width='100%'
                        disabled={loading}
                        onClick={onClick}>{text}</Button>
            </Table.HeaderCell>
        );
    };
